// assets/upside-cart.js  (v2, 2026-10-03)
// Simon 2026-10-03: our own cart drawer, replacing the Rebuy Smart Cart (step 4 of the Rebuy replacement).
// Parity with the Smart Cart as configured on upsidedrinks.ca (Rebuy Smart Cart 22675 + cart widget 139611):
//   - opens on every add to cart (product form, sticky bar, FBT, quick add, collection cards, More like this,
//     Sober October) and on the header cart icon; /cart page untouched
//   - navy announcement bar + free-shipping progress bar: ON/QC $75, rest of Canada $125, hidden for the
//     territories and the US (same rule as rebuy-extensions.liquid setFreeShippingMin + upside-ship-progress.js)
//   - lines: image, title, format, plan, properties, discounts, price with compare-at, -/+ qty, remove
//   - East/West region check ported from ecomific-cart-reconcile.js (Smart Cart branch): lines the region
//     cannot ship are reduced or removed, notice "Cart updated"; a region change redirects to /cart like before
//   - "You may also like": 3 products really bought with the cart items (upside-also.json), filtered like
//     ecomific-rebuy-region-guard.js (east-only / west-only / dev-product tags) and by regional stock;
//     adds go through UDCartBridge.add(..., 'also') so the line carries _ud_src=also
//   - subtotal, delivery estimate slot (.ud-cart__sub, filled by upside-eta.js), Checkout
//   - Sober October module (upside-sober-october.js decorates #ud-cart, node kept across re-renders)
//   - fires 'ud:cart.change' after every change, so the ship bar, BMSM badge and ETA refresh
//   - wholesale customers (Wholesale Gorilla, window.isWsgCustomer) keep the plain theme cart, as today
//   - EN / FR (/fr/), full height on phones, focus trap, Esc closes. No em dashes.
// Simon 2026-10-03 revenue boosters (preview only):
//   - gap closer: below the region's free-shipping threshold, the first suggestion is the product whose price
//     is >= the amount left and as close to it as possible ("Add this and shipping is free"), _ud_src=gap
//   - pack upgrade under a line: next bigger pack with a lower unit price (>= 5% saved), swaps the line, _ud_src=upgrade
//   - 1 recently viewed product (our own localStorage 'ud_recent'), _ud_src=recent
//   - up to 6 suggestions in a swipeable carousel (arrows on desktop): gap, recent, co-purchase, category best sellers
// Public API: window.UDCart.open() / close() / refresh() / add(items) / isOpen()
(function () {
  'use strict';
  if (window.UDCart) return;

  var me = document.currentScript;
  var ALSO_URL = me && me.getAttribute('data-also');
  var FBT_URL = me && me.getAttribute('data-lists');
  var FACTS_URL = me && me.getAttribute('data-facts');
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  // loaded before content_for_header, so Shopify.routes may not exist yet: the URL tells the locale (/fr/...)
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || (/^\/fr(\/|$)/.test(location.pathname) ? '/fr/' : '/');
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  function wholesale() { return typeof window.isWsgCustomer !== 'undefined' && !!window.isWsgCustomer; }
  function onCartPage() {
    return (document.body && document.body.classList.contains('template-cart')) ||
      /^\/(fr\/)?cart\/?$/.test(location.pathname);
  }

  var T = FR ? {
    title: 'Votre panier', close: 'Fermer le panier',
    announce: 'QC et ON : livraison gratuite dès 75 $ | Ouest dès 125 $ | Atlantique dès 150 $',
    away: function (m) { return 'Seulement <strong>' + m + '</strong> jusqu\'à la livraison gratuite'; },
    reached: '<b>Oui! Livraison gratuite! 🚐</b>',
    progress: 'Progression vers la livraison gratuite',
    empty: '<h4>Votre panier est encore vide! 😔</h4><p>Remplissez-le avec vos produits préférés!</p><p><a href="' + ROOT + 'collections/all">Magasiner</a></p>',
    subtotal: 'Sous-total', checkout: 'Passer la commande maintenant', checkingOut: 'Commande en cours...',
    also: 'Vous aimerez peut-être aussi', add: 'Ajouter', adding: 'Ajout...',
    remove: function (t) { return 'Retirer ' + t; }, dec: function (t) { return 'Diminuer la quantité de ' + t; },
    inc: function (t) { return 'Augmenter la quantité de ' + t; }, qty: function (t) { return 'Quantité de ' + t; },
    dismiss: 'Fermer le message', updated: 'Panier mis à jour', error: 'Oups, une erreur est survenue. Réessayez.',
    each: 'ch.', gift: 'Cadeau',
    gap: 'Ajoutez ceci et la livraison est gratuite', recent: 'Vu récemment',
    upgrade: function (v, pct) { return 'Passer au ' + v + ', économisez ' + pct + ' %'; },
    prev: 'Suggestions précédentes', next: 'Suggestions suivantes', upgrading: 'Un instant...'
  } : {
    title: 'Your Cart', close: 'Close cart',
    announce: 'ON & QC: free shipping on $75+ | West: $125+ | Atlantic: $150+',
    away: function (m) { return 'You are <strong>' + m + ' away</strong> from <b>FREE SHIPPING</b>'; },
    reached: '&#127881; Congrats! You\'ve unlocked <b>FREE SHIPPING!</b>',
    progress: 'Progress to free shipping',
    empty: '<h4>Your cart is empty!</h4><p>Add your favorite items to your cart.</p><p><a href="' + ROOT + 'collections/all">Shop Now</a></p>',
    subtotal: 'Subtotal', checkout: 'Checkout', checkingOut: 'Checking Out...',
    also: 'You may also like', add: 'Add', adding: 'Adding...',
    remove: function (t) { return 'Remove ' + t; }, dec: function (t) { return 'Decrease quantity of ' + t; },
    inc: function (t) { return 'Increase quantity of ' + t; }, qty: function (t) { return 'Quantity of ' + t; },
    dismiss: 'Dismiss cart update message', updated: 'Cart updated', error: 'Oops, something went wrong. Please try again.',
    each: 'ea.', gift: 'Gift',
    gap: 'Add this and shipping is free', recent: 'Recently viewed',
    upgrade: function (v, pct) { return 'Upgrade to ' + v + ', save ' + pct + '%'; },
    prev: 'Previous suggestions', next: 'Next suggestions', upgrading: 'One moment...'
  };

  // ecomific-cart-reconcile.js messages (translated by Liquid in layout/theme.liquid)
  function M() {
    var c = window.ecomificAvailabilityConfig, m = (c && c.messages) || {};
    function g(k, en, fr) { var v = String(m[k] || '').trim(); return v || (FR ? fr : en); }
    return {
      updatedTitle: g('updatedTitle', 'Cart updated', 'Panier mis à jour'),
      inventoryAdjusted: g('inventoryAdjusted', 'We’ve updated your cart based on availability in your shipping region.', 'Nous avons mis à jour votre panier selon la disponibilité dans votre région de livraison.'),
      cartEmptied: g('cartEmptied', 'The items in your cart are not available in this shipping region, so your cart is now empty.', 'Les articles de votre panier ne sont pas disponibles dans cette région de livraison, votre panier est donc vide.'),
      unavailable: g('unavailable', 'This item is not available based on current inventory for your shopping region.', 'Cet article n\'est pas disponible dans votre région.'),
      one: g('quantityLimitedOne', 'Only [quantity] item available in your region.', 'Seulement [quantity] article disponible dans votre région.'),
      other: g('quantityLimitedOther', 'Only [quantity] items available in your region.', 'Seulement [quantity] articles disponibles dans votre région.'),
      dismiss: g('dismissLabel', T.dismiss, T.dismiss)
    };
  }
  function limited(q, title) {
    var m = M(), base = (q === 1 ? m.one : m.other).split('[quantity]').join(String(q)).split('{{ quantity }}').join(String(q));
    base = base.replace(/\s+/g, ' ').trim();
    return title ? title + ': ' + base : base;
  }

  // ---------- helpers ----------
  function money(c) { return '$' + ((c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function readLS(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function cookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function region() {
    var d = (document.documentElement.dataset && document.documentElement.dataset.ecomificRegion) || '';
    var v = String(d || readLS('ecomific_region') || cookie('ecomific_region')).toLowerCase().trim();
    return v === 'east' || v === 'west' ? v : '';
  }
  // province the header "Delivery: ..." selector uses (same source as upside-eta.js and the PDP ship bar)
  function province() {
    var p = '';
    try { var L = window.ecomificShoppingLocation; p = (L && L.getLocation && L.getLocation()) || ''; } catch (e) {}
    if (!p) p = cookie('ecomific_shopping_location');
    return String(p || '').trim().toUpperCase();
  }
  // Shipping zones 2026: EAST (ON, QC) free from $75, ROC (AB, BC, MB, SK) from $125, ATLANTIC (NB, NS, PE, NL) from $150 (both were $145 until 2026-10-08), territories and US: no bar
  var ROC = ['AB', 'BC', 'MB', 'SK'];
  var ATL = ['NB', 'NS', 'PE', 'NL'];
  function threshold() {
    var p = province();
    if (p === 'ON' || p === 'QC') return 7500;
    if (ROC.indexOf(p) > -1) return 12500;
    if (ATL.indexOf(p) > -1) return 15000;
    return null;
  }
  function isThemePreview() {
    try { if (window.Shopify && Shopify.designMode) return true; } catch (e) {}
    try { return sessionStorage.getItem('ecomific_theme_preview') === '1'; } catch (e) { return false; }
  }
  function packCount(t) { t = String(t || '').toLowerCase(); if (/^1\s*(can|canette)\b/.test(t)) return 1; var n = t.match(/^(\d+)/); return n ? +n[1] : 1; }
  // units in a format: "4 Pack", "24 Pack", "6 Bottles", "12 canettes", "1 Can" -> number; anything else -> null
  function packN(t) {
    t = String(t || '').toLowerCase();
    var m = t.match(/(\d+)\s*-?\s*(pack|pk|bottles?|bouteilles?|cans?|canettes?|btl)\b/);
    if (m) return +m[1];
    if (/^(single|unit|unité|1)\b/.test(t)) return 1;
    return null;
  }
  function label(t) { return String(t || '').replace(/\s*\(.*?\)\s*/g, ' ').trim(); }
  function invBase() {
    var c = window.ecomificAvailabilityConfig;
    var raw = String((c && (c.endpointBase || c.inventoryApiBase)) || window.ECOMIFIC_INVENTORY_ENDPOINT_URL || '').trim().replace(/\/+$/, '');
    if (!/^https?:\/\//i.test(raw)) return '';
    if (raw.indexOf('/.netlify/functions') > -1) return /\/\.netlify\/functions$/.test(raw) ? raw + '/inventory' : raw;
    return /\/inventory$/.test(raw) ? raw : raw + '/inventory';
  }

  var _fetch = window.fetch.bind(window);
  var MARK = 'X-UD-Cart';
  function api(url, body) {
    var o = { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' };
    o.headers[MARK] = '1';
    if (body !== undefined) {
      o.method = 'POST';
      if (body instanceof FormData) o.body = body;
      else { o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    }
    return _fetch(url, o).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || String(r.status)); e.data = j; e.status = r.status; throw e; } return j; });
    });
  }
  function getJSON(u) { return _fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }
  function changed(src) { try { document.dispatchEvent(new CustomEvent('ud:cart.change', { detail: { source: src || 'ud-cart' } })); } catch (e) {} }

  // product JSON (compare-at, tags, variants), cached for the page
  var prodMem = {};
  function productJs(path) {
    path = String(path || '').split('?')[0].split('#')[0];
    if (!path) return Promise.resolve(null);
    if (!prodMem[path]) prodMem[path] = getJSON(path + '.js').catch(function () { delete prodMem[path]; return null; });
    return prodMem[path];
  }

  // ---------- recently viewed (our own list: handle as seen + locale) ----------
  var RECENT_KEY = 'ud_recent';
  function recentList() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]') || []; } catch (e) { return []; } }
  (function trackView() {
    var m = location.pathname.match(/^\/(fr\/)?products\/([^\/?#]+)/);
    if (!m) return;
    var h = decodeURIComponent(m[2]), fr = !!m[1];
    try {
      var l = recentList().filter(function (x) { return x && x.h !== h; });
      l.unshift({ h: h, fr: fr, t: Date.now() });
      localStorage.setItem(RECENT_KEY, JSON.stringify(l.slice(0, 12)));
    } catch (e) {}
  })();

  // ---------- regional inventory (same service and rules as ecomific-cart-reconcile.js) ----------
  var invMem = {};
  function inventory(variantId, reg, maxAge) {
    var base = invBase(); if (!base || !reg) return Promise.resolve(null);
    var k = variantId + '|' + reg, c = invMem[k];
    if (c && Date.now() - c.t < (maxAge || 60000)) return c.p;
    var p = _fetch(base + '?variant_id=' + encodeURIComponent(variantId) + '&region=' + encodeURIComponent(reg), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (a) {
        if (!a) return null;
        return {
          ok: a.ok === true, available: a.available === true,
          quantity: a.quantity == null ? null : Number(a.quantity || 0),
          tracked: typeof a.tracked === 'boolean' ? a.tracked : null,
          availableForSale: a.available_for_sale === true,
          inventoryPolicy: typeof a.inventory_policy === 'string' ? a.inventory_policy.trim().toUpperCase() : null
        };
      })
      .catch(function () { delete invMem[k]; return null; });
    invMem[k] = { t: Date.now(), p: p };
    return p;
  }
  function nativeAvail(a) { return !!a && a.availableForSale === true && (a.tracked === false || a.inventoryPolicy === 'CONTINUE'); }
  // allowed quantity for a line in the region (Infinity = no limit), or null when unknown
  function allowedQty(a) {
    if (!a || a.ok !== true) return null;
    if (a.available !== true) return 0;
    if (!nativeAvail(a) && isFinite(a.quantity) && a.quantity !== null) return Math.max(0, a.quantity);
    return Infinity;
  }
  function regionOk(a) { var q = allowedQty(a); return q === null || q > 0; }

  // ---------- data for "You may also like" ----------
  var dataP = null;
  function data() {
    if (!dataP) dataP = Promise.all([
      ALSO_URL ? getJSON(ALSO_URL).catch(function () { return {}; }) : {},
      FACTS_URL ? getJSON(FACTS_URL).catch(function () { return {}; }) : {},
      FBT_URL ? getJSON(FBT_URL).catch(function () { return {}; }) : {}
    ]).then(function (r) {
      var fr = (r[2] && r[2]._fr) || {}, back = {};
      for (var en in fr) back[fr[en]] = en;
      return { also: r[0] || {}, facts: r[1] || {}, fr: fr, back: back, fbtLists: r[2] || {} };
    });
    return dataP;
  }

  // ---------- DOM ----------
  var BLUE = '#37446E';
  var css = [
    '#ud-cart{position:fixed;inset:0;z-index:2147483000;visibility:hidden;pointer-events:none}',
    '#ud-cart.is-visible{visibility:visible;pointer-events:auto}',
    '.ud-cart__overlay{position:absolute;inset:0;background:rgba(17,24,39,.45);opacity:0;transition:opacity .25s}',
    '#ud-cart.is-visible .ud-cart__overlay{opacity:1}',
    '.ud-cart__panel{position:absolute;top:10px;right:10px;bottom:10px;width:500px;max-width:calc(100% - 20px);background:#fff;display:flex;flex-direction:column;transform:translateX(110%);transition:transform .28s ease;box-shadow:-6px 0 24px rgba(0,0,0,.12);border-radius:10px;overflow:hidden;font-family:inherit;color:#1f2937;outline:0}',
    '#ud-cart.is-visible .ud-cart__panel{transform:none}',
    '.ud-cart__head{display:flex;align-items:center;justify-content:center;position:relative;padding:14px 52px;border-bottom:1px solid #eef0f4;flex:0 0 auto}',
    '.ud-cart__title{font-size:18px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;margin:0;text-align:center}',
    '.ud-cart__x{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:40px;height:40px;border:0;background:none;font-size:28px;line-height:1;cursor:pointer;color:#111;border-radius:6px}',
    '.ud-cart__x:focus-visible,.ud-cart__panel button:focus-visible,.ud-cart__panel a:focus-visible,.ud-cart__panel input:focus-visible{outline:2px solid ' + BLUE + ';outline-offset:2px}',
    '.ud-cart__announce{background:' + BLUE + ';color:#fff;text-align:center;font-size:13.5px;padding:8px 14px;flex:0 0 auto}',
    '.ud-cart__progress{padding:10px 20px 14px;flex:0 0 auto}',
    '.ud-cart__progress[hidden]{display:none}',
    '.ud-cart__progress p{margin:0 0 8px;font-size:13px;text-align:center;line-height:1.35}',
    '.ud-cart__progress strong{color:#d0021b}',
    '.ud-cart__bar{height:8px;background:#e8e8e8;border-radius:6px;overflow:hidden}',
    '.ud-cart__bar span{display:block;height:100%;background:' + BLUE + ';border-radius:6px;transition:width .3s}',
    '.ud-cart__body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;border-top:1px solid #eef0f4}',
    '.ud-cart__notices:empty{display:none}',
    '.ud-cart__notices{padding:10px 20px 0}',
    '.ud-cart__notice{position:relative;margin:0 0 8px;padding:10px 36px 10px 12px;border-radius:8px;background:#fff7e6;border:1px solid #f5d38a;font-size:13px;line-height:1.4}',
    '.ud-cart__notice p{margin:0}.ud-cart__notice p+p{margin-top:3px}',
    '.ud-cart__notice.is-error{background:#fdecec;border-color:#f3b4b4}',
    '.ud-cart__notice button{position:absolute;top:4px;right:4px;width:28px;height:28px;border:0;background:none;font-size:18px;cursor:pointer;color:#6b7280}',
    '.ud-cart__items{padding:0 20px}',
    '.ud-cart__item{display:flex;gap:14px;padding:18px 0;border-bottom:1px solid #eef0f4;position:relative}',
    '.ud-cart__item:last-child{border-bottom:0}',
    '.ud-cart__img{flex:0 0 84px;height:84px;display:flex;align-items:center;justify-content:center}',
    '.ud-cart__img img{max-width:100%;max-height:100%;object-fit:contain}',
    '.ud-cart__info{flex:1 1 auto;min-width:0;padding-right:28px}',
    '.ud-cart__name{font-size:14.5px;font-weight:700;color:inherit;text-decoration:none;display:block;line-height:1.3}',
    '.ud-cart__variant,.ud-cart__prop{font-size:12.5px;color:#6b7280;margin-top:2px}',
    '.ud-cart__row{display:flex;align-items:center;justify-content:space-between;margin-top:10px;gap:8px}',
    '.ud-cart__qty{display:inline-flex;border:1px solid #d6d9e0;border-radius:3px;height:32px}',
    '.ud-cart__qty button{width:34px;border:0;background:#fff;font-size:17px;cursor:pointer;color:#111;padding:0}',
    '.ud-cart__qty button:disabled{opacity:.4;cursor:default}',
    '.ud-cart__qty input{width:38px;border:0;border-left:1px solid #d6d9e0;border-right:1px solid #d6d9e0;text-align:center;font-size:14px;-moz-appearance:textfield;padding:0;border-radius:0;background:#fff;color:#111}',
    '.ud-cart__qty input::-webkit-outer-spin-button,.ud-cart__qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}',
    '.ud-cart__price{font-size:14px;text-align:right;white-space:nowrap}',
    '.ud-cart__price s{display:block;color:#9aa0a6;font-size:12px}',
    '.ud-cart__price.is-sale span{color:#c0392b;font-weight:600}',
    '.ud-cart__rm{position:absolute;top:14px;right:0;width:30px;height:30px;border:0;background:none;color:#9aa0a6;font-size:20px;cursor:pointer;line-height:1;padding:0}',
    '.ud-cart__rm:hover{color:#111}',
    '.ud-cart__disc{font-size:12px;color:#1c7c3c;margin-top:3px}',
    '.ud-cart__empty{text-align:center;padding:36px 24px}',
    '.ud-cart__empty h4{font-size:18px;margin:0 0 8px}',
    '.ud-cart__empty p{margin:0 0 6px}',
    '.ud-cart__empty a{display:inline-block;margin-top:8px;background:' + BLUE + ';color:#fff;padding:11px 24px;border-radius:4px;text-decoration:none;font-weight:700}',
    '.ud-cart__also{padding:16px 0 18px;background:#f7f7f7}',
    '.ud-cart__also[hidden]{display:none}',
    '.ud-cart__also h5{font-size:17px;font-weight:600;margin:0 0 12px;text-align:center;padding:0 20px}',
    '.ud-cart__rail{position:relative}',
    '.ud-cart__track{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-padding:0 20px;padding:2px 20px 6px;-webkit-overflow-scrolling:touch;scrollbar-width:none;overscroll-behavior-x:contain}',
    '.ud-cart__track::-webkit-scrollbar{display:none}',
    '.ud-cart__card{flex:0 0 148px;scroll-snap-align:start;display:flex;flex-direction:column;background:#fff;border:1px solid #e5e7eb;border-radius:8px;padding:10px;position:relative}',
    '.ud-cart__card.is-gap{border-color:#0b6e4f;box-shadow:0 0 0 1px #0b6e4f}',
    '.ud-cart__tag{display:block;margin:-2px 0 6px;font-family:Arial,Helvetica,sans-serif;font-size:10.5px;font-weight:700;line-height:1.25;color:#0b6e4f;text-transform:uppercase;letter-spacing:.02em}',
    '.ud-cart__tag.is-recent{color:#6b7280}',
    '.ud-cart__card img{width:100%;height:96px;object-fit:contain;display:block;margin-bottom:8px}',
    '.ud-cart__card .ud-cart__cname{font-size:13px;line-height:1.3;color:inherit;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:34px}',
    '.ud-cart__card small{display:block;color:#111;font-size:13px;font-weight:600;margin-top:4px}',
    '.ud-cart__pills{display:flex;flex-wrap:wrap;gap:4px;margin-top:6px}',
    '.ud-cart__card .ud-cart__pill{height:auto;font-family:Arial,Helvetica,sans-serif;font-size:10.5px;font-weight:400;line-height:1;padding:4px 7px;border:1px solid #d6d9e0;border-radius:11px;background:#fff;color:' + BLUE + ';cursor:pointer}',
    '.ud-cart__card .ud-cart__pill.is-on{background:' + BLUE + ';border-color:' + BLUE + ';color:#fff}',
    '.ud-cart__card .ud-cart__spacer{flex:1 1 auto;min-height:8px}',
    '.ud-cart__card .ud-cart__addbtn{width:100%;height:34px;padding:0 10px;border:0;background:' + BLUE + ';color:#fff;font-weight:700;font-size:12.5px;letter-spacing:.04em;text-transform:uppercase;border-radius:4px;cursor:pointer}',
    '.ud-cart__card .ud-cart__addbtn:disabled{opacity:.6;cursor:default}',
    '.ud-cart__arrow{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;border:1px solid #d6d9e0;background:#fff;color:#111;font-size:20px;line-height:1;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,.12);z-index:2;display:flex;align-items:center;justify-content:center;padding:0 0 3px}',
    '.ud-cart__arrow[disabled]{opacity:0;pointer-events:none}',
    '.ud-cart__arrow--prev{left:6px}.ud-cart__arrow--next{right:6px}',
    '@media (max-width:600px),(hover:none){.ud-cart__arrow{display:none}}',
    '.ud-cart__up{display:inline-block;margin-top:8px;padding:0;border:0;background:none;color:#0b6e4f;font-size:12.5px;font-weight:700;text-decoration:underline;cursor:pointer;text-align:left}',
    '.ud-cart__up:disabled{opacity:.6;cursor:default}',
    '.ud-cart__footer{padding:14px 20px calc(14px + env(safe-area-inset-bottom));border-top:1px solid #eef0f4;background:#fff;flex:0 0 auto}',
    '.ud-cart__footer[hidden]{display:none}',
    '.ud-cart__sub{display:flex;justify-content:space-between;font-size:17px;font-weight:700;margin-bottom:4px}',
    '.ud-cart__checkout{width:100%;min-height:50px;border:0;background:' + BLUE + ';color:#fff;font-size:17px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;border-radius:4px;cursor:pointer;margin-top:4px;padding:8px 12px}',
    '.ud-cart__checkout:hover{background:#2a3456}',
    '.ud-cart__checkout:disabled{opacity:.7}',
    '.ud-cart__accel{margin-top:10px}.ud-cart__accel:empty{display:none}',
    '.ud-cart__sr{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
    '#ud-cart.is-busy .ud-cart__items,#ud-cart.is-busy .ud-cart__sub{opacity:.55;pointer-events:none}',
    'html.ud-cart-open,html.ud-cart-open body{overflow:hidden}',
    // chat bubbles sit on top of Checkout: hide them while the cart is open
    'html.ud-cart-open #gorgias-chat-container,html.ud-cart-open iframe#chat-button,html.ud-cart-open [class*="bpFab"],html.ud-cart-open [class*="bpWidget"]{display:none!important}',
    '@media (max-width:600px){.ud-cart__panel{top:0;right:0;bottom:0;width:100%;max-width:100%;height:100%;height:100dvh;border-radius:0}.ud-cart__items,.ud-cart__also,.ud-cart__notices{padding-left:16px;padding-right:16px}.ud-cart__footer{padding-left:16px;padding-right:16px}}'
  ].join('');

  var root, panel, els = {}, lastFocus = null;
  function build() {
    if (root) return;
    var st = document.createElement('style'); st.id = 'ud-cart-css'; st.textContent = css; document.head.appendChild(st);
    root = document.createElement('div');
    root.id = 'ud-cart';
    root.className = 'ud-cart';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="ud-cart__overlay" data-close></div>' +
      '<div class="ud-cart__panel ud-cart__flyout" role="dialog" aria-modal="true" aria-labelledby="UDCartTitle" tabindex="-1">' +
        '<div class="ud-cart__head"><p class="ud-cart__title" id="UDCartTitle">' + esc(T.title) + '</p><button type="button" class="ud-cart__x" data-close aria-label="' + esc(T.close) + '">&times;</button></div>' +
        '<div class="ud-cart__announce">' + esc(T.announce) + '</div>' +
        '<div class="ud-cart__progress" hidden></div>' +
        '<div class="ud-cart__body"><div class="ud-cart__notices" role="status"></div><div class="ud-cart__items"></div><div class="ud-cart__also" hidden></div></div>' +
        '<div class="ud-cart__footer" hidden>' +
          '<div class="ud-cart__sub"><span>' + esc(T.subtotal) + '</span><span class="ud-cart__subamt"></span></div>' +
          '<button type="button" class="ud-cart__checkout" data-checkout>' + esc(T.checkout) + '</button>' +
          '<div class="ud-cart__accel"></div>' +
        '</div>' +
        '<div class="ud-cart__sr" aria-live="polite"></div>' +
        '<span class="ud-cart__sr" tabindex="0" data-trap="end"></span>' +
      '</div>';
    document.body.appendChild(root);
    panel = root.querySelector('.ud-cart__panel');
    ['progress', 'notices', 'items', 'also', 'footer', 'subamt', 'sr', 'accel'].forEach(function (k) { els[k] = root.querySelector('.ud-cart__' + k); });
    // accelerated checkout buttons, when the theme renders them (snippet ud-cart-accel in layout/theme.liquid)
    var ac = document.getElementById('ud-cart-accel-src');
    if (ac && ac.firstElementChild) els.accel.appendChild(ac.firstElementChild);
    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    root.addEventListener('keydown', onKey);
    // focus trap: the wallet buttons (PayPal) are iframes, Tab can leave them past the panel
    panel.querySelector('[data-trap="end"]').addEventListener('focus', function () { var f = focusables(); if (f[0]) f[0].focus(); });
    document.addEventListener('focusin', function (e) {
      if (isOpen() && panel && !panel.contains(e.target)) { var f = focusables(); (f[0] || panel).focus(); }
    });
  }
  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,iframe,[tabindex]:not([tabindex="-1"])'), function (n) {
      if (n.hasAttribute('data-trap')) return false;
      return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
    });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.ud-cart__qty input')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last && !(els.accel && els.accel.querySelector('*'))) { e.preventDefault(); first.focus(); }
  }
  function say(t) { if (els.sr) { els.sr.textContent = ''; setTimeout(function () { els.sr.textContent = t; }, 50); } }

  // ---------- state ----------
  var cart = null, notices = [];
  function isOpen() { return !!(root && root.classList.contains('is-visible')); }
  function open() {
    if (wholesale()) { location.href = ROOT + 'pages/ws-cart'; return Promise.resolve(); }
    build();
    if (!isOpen()) {
      lastFocus = document.activeElement;
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ud-cart-open');
      setTimeout(function () { var x = root.querySelector('.ud-cart__x'); if (x) x.focus({ preventScroll: true }); }, 30);
      try { document.dispatchEvent(new CustomEvent('ud:cart.open')); } catch (e) {}
    }
    return refresh().then(function () { reconcile(); });
  }
  function close() {
    if (!root || !isOpen()) return;
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ud-cart-open', 'cart-open');
    notices = []; renderNotices();
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('ud:cart.close')); } catch (e) {}
  }
  var refreshP = null;
  function refresh() {
    if (refreshP) return refreshP;
    refreshP = api(ROOT + 'cart.js').then(function (c) { cart = c; badge(); if (root) render(); return c; })
      .catch(function () { return cart; })
      .then(function (c) { setTimeout(function () { refreshP = null; }, 80); return c; });
    return refreshP;
  }
  function setCart(c) { cart = c; badge(); if (root) render(); }
  function badge() {
    if (!cart) return;
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (n) { n.textContent = cart.item_count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
  }

  // ---------- render ----------
  function shippingTotal() {
    if (!cart) return 0;
    var excl = 0;
    (cart.items || []).forEach(function (it) { if (it.requires_shipping === false) excl += it.final_line_price; });
    return Math.max(0, cart.total_price - excl);
  }
  function renderProgress() {
    var goal = threshold();
    if (!goal || !cart) { els.progress.hidden = true; return; }
    var total = shippingTotal(), left = Math.max(0, goal - total), pct = Math.min(100, Math.round(total / goal * 100));
    els.progress.innerHTML = '<p>' + (left > 0 ? T.away(money(left)) : T.reached) + '</p>' +
      '<div class="ud-cart__bar" role="progressbar" aria-label="' + esc(T.progress) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
    els.progress.hidden = false;
  }
  function renderNotices() {
    if (!els.notices) return;
    els.notices.innerHTML = notices.map(function (n, i) {
      return '<div class="ud-cart__notice ecomific-cart-notice' + (n.error ? ' is-error' : '') + '">' +
        (n.title ? '<p><strong>' + esc(n.title) + '</strong></p>' : '') + '<p>' + esc(n.message) + '</p>' +
        '<button type="button" data-dismiss="' + i + '" aria-label="' + esc(M().dismiss) + '">&times;</button></div>';
    }).join('');
  }
  function notify(n) {
    if (notices[0] && notices[0].title === n.title && notices[0].message === n.message) return;
    notices.unshift(n); renderNotices(); say(n.message);
  }
  var compareMem = {};
  function lineHtml(it) {
    var title = it.product_title || it.title || '';
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? label(it.variant_title) : '';
    var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.name : '';
    var props = [], gift = false;
    var P = it.properties || {};
    for (var k in P) {
      if (!P[k] || String(k).charAt(0) === '_') continue;
      if (/gift.with.purchase/i.test(P[k])) gift = true;
      props.push('<div class="ud-cart__prop">' + esc(k) + ': ' + esc(P[k]) + '</div>');
    }
    if (P._rebuy_gift || /gift.with.purchase/i.test(JSON.stringify(P))) gift = true;
    var disc = (it.line_level_discount_allocations || []).map(function (d) {
      var t = d.discount_application && d.discount_application.title;
      return t ? esc(t) + ' (-' + money(d.amount) + ')' : '';
    }).filter(Boolean).join(', ');
    var cmpUnit = compareMem[it.variant_id] || 0;
    var strike = Math.max(it.original_line_price || 0, cmpUnit * it.quantity);
    var sale = strike > it.final_line_price;
    var t = esc(title);
    return '<div class="ud-cart__item rebuy-cart__flyout-item-like" data-key="' + esc(it.key) + '" role="group" aria-label="' + t + '">' +
      '<a class="ud-cart__img" href="' + esc(it.url) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="' + t + '" loading="lazy">' : '') + '</a>' +
      '<div class="ud-cart__info"><a class="ud-cart__name" href="' + esc(it.url) + '">' + t + '</a>' +
        (variant ? '<div class="ud-cart__variant">' + esc(variant) + '</div>' : '') +
        (plan ? '<div class="ud-cart__variant">' + esc(plan) + '</div>' : '') + props.join('') +
        (disc ? '<div class="ud-cart__disc">' + disc + '</div>' : '') +
        '<div class="ud-cart__row">' +
          (gift ? '<span class="ud-cart__variant">' + esc(T.gift) + ' x ' + it.quantity + '</span>' :
          '<span class="ud-cart__qty"><button type="button" data-qty="-1" aria-label="' + esc(T.dec(title)) + '">&minus;</button>' +
          '<input type="number" inputmode="numeric" min="0" value="' + it.quantity + '" aria-label="' + esc(T.qty(title)) + '">' +
          '<button type="button" data-qty="1" aria-label="' + esc(T.inc(title)) + '">+</button></span>') +
          '<span class="ud-cart__price' + (sale ? ' is-sale' : '') + '"><span>' + money(it.final_line_price) + '</span>' + (sale ? '<s>' + money(strike) + '</s>' : '') + '</span>' +
        '</div>' + upgradeHtml(it, gift) +
      '</div>' +
      (gift ? '' : '<button type="button" class="ud-cart__rm" data-rm aria-label="' + esc(T.remove(title)) + '">&times;</button>') +
    '</div>';
  }
  // compare-at prices are not in /cart.js: read them from the product JSON once, then re-render
  function loadCompare() {
    var need = (cart.items || []).filter(function (it) { return !(it.variant_id in compareMem); });
    if (!need.length) return;
    Promise.all(need.map(function (it) {
      return productJs(it.url).then(function (p) {
        var v = p && (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
        compareMem[it.variant_id] = v && v.compare_at_price > v.price ? v.compare_at_price : 0;
        return compareMem[it.variant_id];
      });
    })).then(function (r) { if (r.some(Boolean) && root) renderItems(); });
  }
  // ---------- pack upgrade (next bigger pack, lower unit price, >= 5% saved, shippable in the region) ----------
  var upMem = {}, upDone = {}; // variant id -> null | { v, pct }
  function upgradeHtml(it, gift) {
    if (gift || it.selling_plan_allocation) return '';
    var u = upMem[it.variant_id + '|' + region()];
    if (!u) return '';
    return '<div><button type="button" class="ud-cart__up" data-upgrade="' + u.v.id + '">' + esc(T.upgrade(label(u.v.title), u.pct)) + '</button></div>';
  }
  function loadUpgrades() {
    var reg = region();
    var need = (cart.items || []).filter(function (it) { return !it.selling_plan_allocation && !upDone[it.variant_id + '|' + reg]; });
    if (!need.length) return;
    need.forEach(function (it) { upDone[it.variant_id + '|' + reg] = 1; });
    Promise.all(need.map(function (it) {
      return productJs(it.url).then(function (p) {
        if (!p) return false;
        var cur = (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
        var n0 = cur && packN(cur.title);
        if (!n0) return false;
        var bigger = p.variants.filter(function (v) { var n = packN(v.title); return v.available && n && n > n0; })
          .sort(function (a, b) { return packN(a.title) - packN(b.title); })
          .map(function (v) { var n = packN(v.title); return { v: v, pct: Math.round((1 - (v.price / n) / (cur.price / n0)) * 100) }; })
          .filter(function (c) { return c.pct >= 5; });
        // the next bigger pack the region can ship
        var i = 0;
        var next = function () {
          var c = bigger[i++]; if (!c) return null;
          return (reg ? inventory(c.v.id, reg, 300000).then(regionOk) : Promise.resolve(true)).then(function (ok) { return ok ? c : next(); });
        };
        return Promise.resolve(next()).then(function (c) { upMem[it.variant_id + '|' + reg] = c || null; return !!c; });
      });
    })).then(function (r) { if (r.some(Boolean) && root && cart) renderItems(); });
  }
  function upgrade(key, vid, btn) {
    var it = cart && cart.items.filter(function (i) { return i.key === key; })[0];
    var u = it && upMem[it.variant_id + '|' + region()];
    if (!it || !u || u.v.id !== vid) return;
    btn.disabled = true; btn.textContent = T.upgrading;
    notices = []; renderNotices();
    var n0 = packN(it.variant_title) || 1, n = packN(u.v.title) || 1;
    var q = Math.max(1, Math.floor(it.quantity * n0 / n));
    var props = {};
    for (var k in (it.properties || {})) if (it.properties[k] && String(k).charAt(0) !== '_') props[k] = it.properties[k];
    var already = cart.items.some(function (i) { return i.variant_id === vid; });
    if (!already) props._ud_src = 'upgrade';
    var item = { id: vid, quantity: q };
    if (Object.keys(props).length) item.properties = props;
    busy(true);
    // add the bigger pack first, then drop the old line: nothing is lost if the add fails
    api(ROOT + 'cart/add.js', { items: [item] })
      .then(function () { return api(ROOT + 'cart/change.js', { id: key, quantity: 0 }); })
      .then(function (c) { setCart(c); changed('upgrade'); say(T.updated); })
      .catch(function (e) { notify({ message: (e && e.message) || T.error, error: true }); return refresh(); })
      .then(function () { busy(false); reconcile(); });
  }

  function renderItems() {
    // keep the Sober October module (upside-sober-october.js) across re-renders, no flicker
    // (it may have been placed before the footer while the cart was empty: always bring it back above the lines)
    var so = root.querySelector('.upside-so-inject');
    if (so) so.parentNode.removeChild(so);
    if (!cart.items.length) {
      els.items.innerHTML = '<div class="ud-cart__empty">' + T.empty + '</div>';
    } else {
      els.items.innerHTML = cart.items.map(lineHtml).join('');
    }
    if (so) els.items.insertBefore(so, els.items.firstChild);
  }
  function render() {
    if (!cart) return;
    renderProgress();
    renderNotices();
    renderItems();
    loadCompare();
    loadUpgrades();
    var has = cart.items.length > 0;
    els.footer.hidden = !has;
    els.subamt.textContent = money(cart.total_price);
    if (!has) { els.also.hidden = true; alsoKey = ''; return; }
    renderAlso();
  }

  // ---------- "You may also like" ----------
  var alsoKey = '', upsell = [];
  function upsellCard(m) {
    var p = m.p, v = m.v, src = (v.featured_image && v.featured_image.src) || p.featured_image;
    var pills = m.ok.length > 1 ? '<span class="ud-cart__pills" role="group">' + m.ok.map(function (x) {
      return '<button type="button" class="ud-cart__pill' + (x.id === v.id ? ' is-on' : '') + '" aria-pressed="' + (x.id === v.id) + '" data-pv="' + x.id + '">' + esc(label(x.title)) + '</button>';
    }).join('') + '</span>' : (label(v.title) && v.title !== 'Default Title' ? '<span class="ud-cart__variant">' + esc(label(v.title)) + '</span>' : '');
    var tag = m.src === 'gap' ? '<span class="ud-cart__tag">' + esc(T.gap) + '</span>' :
      (m.src === 'recent' ? '<span class="ud-cart__tag is-recent">' + esc(T.recent) + '</span>' : '');
    return tag + '<img src="' + esc(img(src, 240)) + '" alt="" loading="lazy">' +
      '<a class="ud-cart__cname" href="' + ROOT + 'products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
      '<small>' + money(v.price) + '</small>' + pills + '<span class="ud-cart__spacer"></span>' +
      '<button type="button" class="ud-cart__addbtn" data-add="' + v.id + '" aria-label="' + esc(T.add + ' ' + p.title) + '">' + esc(T.add) + '</button>';
  }
  function tagFlags(p) {
    var s = {}; (p.tags || []).forEach(function (t) { s[String(t).trim().toLowerCase().replace(/[\s_]+/g, '-')] = 1; });
    return s;
  }
  function gapLeft() {
    var goal = threshold();
    if (!goal || !cart) return 0;
    return Math.max(0, goal - shippingTotal());
  }
  // formats of a product the region can ship (product order), cached per product + region
  var okMem = {};
  function okVariants(p, reg) {
    var k = p.id + '|' + reg;
    if (!okMem[k]) {
      var av = p.variants.filter(function (v) { return v.available; });
      okMem[k] = Promise.all(av.map(function (v) { return reg ? inventory(v.id, reg, 300000).then(regionOk) : true; }))
        .then(function (oks) { return av.filter(function (v, i) { return oks[i]; }); });
    }
    return okMem[k];
  }
  function updateArrows() {
    var tr = els.also.querySelector('.ud-cart__track'); if (!tr) return;
    var pv = els.also.querySelector('.ud-cart__arrow--prev'), nx = els.also.querySelector('.ud-cart__arrow--next');
    if (pv) pv.disabled = tr.scrollLeft <= 4;
    if (nx) nx.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
  }
  function renderAlso() {
    var inCart = cart.items.map(function (it) { return it.handle; });
    var inCartIds = {}; cart.items.forEach(function (it) { inCartIds[it.product_id] = 1; });
    var reg = region(), left = gapLeft();
    var rec = recentList();
    var key = inCart.join(',') + '|' + reg + '|' + left + '|' + (rec[0] && rec[0].h);
    if (key === alsoKey) return;
    alsoKey = key;
    data().then(function (d) {
      var enOf = function (h) { return d.back[h] || h; };
      var seen = {}; inCart.map(enOf).forEach(function (h) { seen[h] = 1; });
      var cartEn = inCart.map(enOf).reverse(); // most recently added line first
      // pool, in order: co-purchase lists (upside-also.json: bought together, then category best sellers),
      // then the FBT lists (same brand, category best sellers). Round-robin so every line contributes.
      var pool = [];
      var take = function (lists) {
        for (var round = 0; round < 12 && pool.length < 18; round++) {
          lists.forEach(function (l) {
            var x = l[round]; if (!x || pool.length >= 18) return;
            var a = String(x).split('|'), h = a[0], r = a[1] || '';
            if (seen[h]) return;
            if (r && reg && ((r === 'e' && reg !== 'east') || (r === 'w' && reg !== 'west'))) return;
            seen[h] = 1; pool.push(h);
          });
        }
      };
      take(cartEn.map(function (h) { return d.also[h] || []; }));
      take(cartEn.map(function (h) { return (d.fbtLists && d.fbtLists[h]) || []; }));
      // recently viewed: up to 3 candidates (English handles), not in the cart
      var recent = [];
      rec.forEach(function (x) {
        var h = x && (x.fr ? enOf(x.h) : x.h);
        if (h && recent.length < 3 && !(inCart.map(enOf).indexOf(h) > -1) && recent.indexOf(h) < 0) recent.push(h);
      });
      var all = pool.concat(recent.filter(function (h) { return pool.indexOf(h) < 0; }));
      if (!all.length) { els.also.hidden = true; return; }
      var preview = isThemePreview();
      return Promise.all(all.map(function (h) {
        return productJs(ROOT + 'products/' + ((FR && d.fr[h]) || h)).then(function (p) {
          if (!p || !p.available || inCartIds[p.id]) return null;
          // ecomific-rebuy-region-guard.js rules
          var f = tagFlags(p);
          if (f['dev-product'] && !preview) return null;
          if (reg === 'east' && f['west-only']) return null;
          if (reg === 'west' && f['east-only']) return null;
          if (p.gift_card || /gift.?card|packaging/i.test(p.type || '')) return null;
          return { h: h, p: p };
        });
      })).then(function (rs) {
        if (key !== alsoKey) return;
        var byH = {}; rs.forEach(function (r) { if (r) byH[r.h] = r; });
        // default format: the most sold one (card facts field 5), then packs
        var pref = function (h, ok) {
          var f = d.facts[h];
          return ok.slice().sort(function (a, b) {
            var sa = (f && f[4] === a.id ? 2 : 0) + (packCount(a.title) > 1 ? 1 : 0), sb = (f && f[4] === b.id ? 2 : 0) + (packCount(b.title) > 1 ? 1 : 0);
            return sb - sa;
          })[0];
        };
        var picked = [], used = {};
        // 1. free-shipping gap closer: lowest price >= amount left, pool order breaks ties
        var step = Promise.resolve();
        if (left > 0) {
          var cands = [];
          pool.forEach(function (h, rank) {
            var r = byH[h]; if (!r) return;
            var best = null;
            r.p.variants.forEach(function (v) { if (v.available && v.price >= left && (!best || v.price < best.price)) best = v; });
            if (best) cands.push({ h: h, r: r, d: best.price - left, rank: rank });
          });
          cands.sort(function (a, b) { return a.d - b.d || a.rank - b.rank; });
          var i = 0;
          var tryNext = function () {
            var c = cands[i++]; if (!c || i > 8) return null;
            return okVariants(c.r.p, reg).then(function (ok) {
              var fit = ok.filter(function (v) { return v.price >= left; }).sort(function (a, b) { return a.price - b.price; })[0];
              if (!fit) return tryNext();
              used[c.h] = 1;
              picked.push({ p: c.r.p, v: fit, ok: ok, src: 'gap' });
              return null;
            });
          };
          step = Promise.resolve(tryNext());
        }
        return step.then(function () {
          // 2. one recently viewed product
          var j = 0;
          var nextRecent = function () {
            var h = recent[j++]; if (!h) return null;
            var r = byH[h]; if (!r || used[h]) return nextRecent();
            return okVariants(r.p, reg).then(function (ok) {
              if (!ok.length) return nextRecent();
              used[h] = 1; picked.push({ p: r.p, v: pref(h, ok), ok: ok, src: 'recent' });
              return null;
            });
          };
          return nextRecent();
        }).then(function () {
          // 3. co-purchase, then category best sellers (pool order), 6 cards in all
          var rest = pool.filter(function (h) { return byH[h] && !used[h]; }).slice(0, 10);
          return Promise.all(rest.map(function (h) { return okVariants(byH[h].p, reg).then(function (ok) { return { h: h, ok: ok }; }); }))
            .then(function (rr) {
              rr.forEach(function (x) { if (picked.length < 6 && x.ok.length) picked.push({ p: byH[x.h].p, v: pref(x.h, x.ok), ok: x.ok, src: 'also' }); });
            });
        }).then(function () {
          if (key !== alsoKey) return;
          upsell = picked.slice(0, 6);
          if (!upsell.length) { els.also.hidden = true; return; }
          els.also.innerHTML = '<h5>' + esc(T.also) + '</h5><div class="ud-cart__rail">' +
            '<button type="button" class="ud-cart__arrow ud-cart__arrow--prev" data-scroll="-1" aria-label="' + esc(T.prev) + '">&#8249;</button>' +
            '<div class="ud-cart__track">' + upsell.map(function (m, i) {
              return '<div class="ud-cart__card' + (m.src === 'gap' ? ' is-gap' : '') + '" data-u="' + i + '" data-src="' + m.src + '">' + upsellCard(m) + '</div>';
            }).join('') + '</div>' +
            '<button type="button" class="ud-cart__arrow ud-cart__arrow--next" data-scroll="1" aria-label="' + esc(T.next) + '">&#8250;</button></div>';
          els.also.hidden = false;
          var tr = els.also.querySelector('.ud-cart__track');
          tr.addEventListener('scroll', updateArrows, { passive: true });
          updateArrows();
        });
      });
    }).catch(function () { els.also.hidden = true; });
  }

  // ---------- actions ----------
  function busy(on) { if (root) root.classList.toggle('is-busy', !!on); }
  function change(key, qty, title, before) {
    busy(true);
    qty = Math.max(0, qty | 0);
    return api(ROOT + 'cart/change.js', { id: key, quantity: qty })
      .then(function (c) {
        setCart(c); changed('ud-cart');
        if (qty > before) {
          var now = (c.items || []).filter(function (i) { return i.key === key; })[0];
          if (now && now.quantity < qty) notify({ title: M().updatedTitle, message: limited(now.quantity, title) });
        }
        say(T.updated);
      })
      .catch(function (e) {
        notify({ message: (e && e.message) || T.error, error: true });
        return refresh();
      })
      .then(function () { busy(false); reconcile(); });
  }
  function add(items) {
    var body = items instanceof FormData ? items : { items: items };
    return api(ROOT + 'cart/add.js', body).then(function () { notices = []; changed('ud-cart'); return open(); });
  }
  function onClick(e) {
    var t = e.target;
    var dis = t.closest('[data-dismiss]');
    if (dis) { notices.splice(+dis.getAttribute('data-dismiss'), 1); renderNotices(); return; }
    if (t.closest('[data-close]')) { e.preventDefault(); close(); return; }
    var item = t.closest('.ud-cart__item');
    if (item && cart) {
      var key = item.getAttribute('data-key'), it = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!it) return;
      var q = t.closest('[data-qty]');
      if (q) { notices = []; renderNotices(); change(key, it.quantity + (+q.getAttribute('data-qty')), it.product_title, it.quantity); return; }
      if (t.closest('[data-rm]')) { notices = []; renderNotices(); change(key, 0, it.product_title, it.quantity); return; }
    }
    var sc = t.closest('[data-scroll]');
    if (sc) {
      var tr = els.also.querySelector('.ud-cart__track'), cw = (tr.querySelector('.ud-cart__card') || {}).offsetWidth || 150;
      tr.scrollBy({ left: (+sc.getAttribute('data-scroll')) * (cw + 10) * 2, behavior: 'smooth' });
      return;
    }
    var ug = t.closest('[data-upgrade]');
    if (ug) { var li = ug.closest('.ud-cart__item'); upgrade(li.getAttribute('data-key'), +ug.getAttribute('data-upgrade'), ug); return; }
    var pv = t.closest('[data-pv]');
    if (pv) {
      var card = pv.closest('.ud-cart__card'), m = upsell[+card.getAttribute('data-u')], id = +pv.getAttribute('data-pv');
      m.v = m.ok.filter(function (x) { return x.id === id; })[0] || m.v;
      card.innerHTML = upsellCard(m);
      var nb = card.querySelector('[data-pv="' + id + '"]'); if (nb) nb.focus();
      return;
    }
    var a = t.closest('[data-add]');
    if (a) {
      a.disabled = true; a.textContent = T.adding;
      notices = []; renderNotices();
      var vid = +a.getAttribute('data-add');
      var srcEl = a.closest('[data-src]'), srcTag = (srcEl && srcEl.getAttribute('data-src')) || 'also';
      var B = window.UDCartBridge;
      var p = B && B.add ? B.add([{ id: vid, quantity: 1 }], srcTag) : api(ROOT + 'cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _ud_src: srcTag } }] }).then(function (j) { changed(srcTag); return j; });
      p.then(function () { alsoKey = ''; return refresh(); }).then(function () { reconcile(); })
        .catch(function (err) { notify({ message: (err && (err.description || err.message)) || T.error, error: true }); a.disabled = false; a.textContent = T.add; });
      return;
    }
    if (t.closest('[data-checkout]')) {
      var b = t.closest('[data-checkout]'); b.disabled = true; b.textContent = T.checkingOut;
      window.location.href = ROOT + 'checkout';
    }
  }
  function onChange(e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.ud-cart__qty input')) return;
    var item = inp.closest('.ud-cart__item'), key = item.getAttribute('data-key');
    var it = cart && cart.items.filter(function (i) { return i.key === key; })[0];
    if (!it) return;
    var q = parseInt(inp.value, 10); if (!isFinite(q) || q < 0) q = 0;
    if (q === it.quantity) return;
    notices = []; renderNotices();
    change(key, q, it.product_title, it.quantity);
  }

  // ---------- region check: ecomific-cart-reconcile.js, Smart Cart branch ----------
  var reconciling = false, reconcilePending = false, lastRegionTrigger = 0;
  function reconcile(trigger) {
    if (trigger === 'region') lastRegionTrigger = Date.now();
    var reg = region();
    if (!invBase() || !reg || !cart || !cart.items.length || onCartPage() || wholesale()) return Promise.resolve();
    if (reconciling) { reconcilePending = true; return Promise.resolve(); }
    reconciling = true;
    var items = cart.items.slice();
    var ids = []; items.forEach(function (it) { if (ids.indexOf(it.variant_id) < 0) ids.push(it.variant_id); });
    var res = {};
    // 3 at a time, like the original
    var queue = ids.slice();
    function worker() {
      var id = queue.shift(); if (id == null) return Promise.resolve();
      return inventory(id, reg, 20000).then(function (a) { res[id] = a; return worker(); });
    }
    return Promise.all([worker(), worker(), worker()]).then(function () {
      // any unknown answer: leave the cart alone (same as the Smart Cart branch)
      for (var i = 0; i < ids.length; i++) if (!res[ids[i]] || res[ids[i]].ok !== true) return;
      var used = {}, actions = [];
      items.forEach(function (it) {
        var allow = allowedQty(res[it.variant_id]);
        if (allow === null) return;
        // the same variant on two lines (subscription + one-time) shares the regional stock
        var left = allow === Infinity ? Infinity : Math.max(0, allow - (used[it.variant_id] || 0));
        var q = Math.min(it.quantity, left);
        used[it.variant_id] = (used[it.variant_id] || 0) + q;
        if (q !== it.quantity) actions.push({ key: it.key, q: q, before: it.quantity, title: it.product_title || it.title || 'Item' });
      });
      if (!actions.length) return;
      var removed = actions.filter(function (a) { return a.q <= 0; });
      var lines = actions.filter(function (a) { return a.q > 0 && a.q < a.before; });
      var empty = items.every(function (it) { var a = actions.filter(function (x) { return x.key === it.key; })[0]; return a ? a.q <= 0 : it.quantity <= 0; });
      var regionTriggered = Date.now() - lastRegionTrigger <= 2500;
      var m = M(), copy;
      if (empty && removed.length) copy = m.cartEmptied;
      else if (!regionTriggered && !removed.length && lines.length === 1) copy = limited(lines[0].q, lines[0].title);
      else copy = m.inventoryAdjusted;
      var chain = Promise.resolve();
      actions.forEach(function (a) { chain = chain.then(function () { return api(ROOT + 'cart/change.js', { id: a.key, quantity: a.q }); }); });
      return chain.then(function (c) {
        if (regionTriggered) {
          // same as before: the cart page shows the details (ecomific-cart-reconcile.js reads this key)
          try {
            sessionStorage.setItem('ecomificCartAdjustment', JSON.stringify({
              bannerCopy: copy,
              removedItems: removed.map(function (a) { return { title: a.title, beforeQty: a.before }; }),
              lineChanges: lines.map(function (a) { return { key: '', title: a.title, beforeQty: a.before, afterQty: a.q }; }),
              ts: Date.now()
            }));
          } catch (e) {}
          changed('ud-cart:reconcile');
          location.assign(ROOT + 'cart');
          return;
        }
        if (c) setCart(c);
        notify({ title: m.updatedTitle, message: copy });
        changed('ud-cart:reconcile');
        return refresh();
      });
    }).catch(function () {}).then(function () {
      reconciling = false;
      if (reconcilePending) { reconcilePending = false; setTimeout(reconcile, 750); }
    });
  }

  // ---------- take over add to cart and the header cart icon ----------
  function skip() { return wholesale() || onCartPage(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || skip() || !f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (!f.querySelector('[name="id"]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"], .add-to-cart');
    if (btn) { btn.disabled = true; btn.classList.add('btn--loading'); }
    var fd = new FormData(f);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    add(fd)
      .catch(function (err) {
        build(); notices = [{ message: (err && err.message) || T.error, error: true }];
        return open();
      })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('btn--loading'); } });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#HeaderCartTrigger, .js-drawer-open-cart, [data-ud-cart-open]');
    if (!a || skip()) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);
  // other scripts adding with fetch (theme quick add, FBT, product rows, Sober October...): open / refresh
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = init && init.headers;
    var mine = h && (h[MARK] || (typeof h.get === 'function' && h.get(MARK)));
    var p = _fetch(input, init);
    if (!mine && !skip() && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) {
        if (!r.ok) return;
        setTimeout(function () {
          if (/\/cart\/add/.test(url)) { notices = []; open(); }
          else refresh().then(function () { if (isOpen()) reconcile(); });
          changed('external');
        }, 60);
      }).catch(function () {});
    }
    return p;
  };
  window.addEventListener('ecomific:region:changed', function () { alsoKey = ''; if (cart) { if (root) render(); reconcile('region'); } });
  window.addEventListener('ecomific:region:ready', function () { reconcile(); });
  ['ecomific:shopping-location:ready', 'ecomific:shopping-location:changed'].forEach(function (n) {
    window.addEventListener(n, function () { if (root && cart) renderProgress(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.UDCart = { open: open, close: close, refresh: refresh, add: add, isOpen: isOpen, reconcile: reconcile };
  // header bubble right on first load, and the region check like the Smart Cart did on every page
  function boot() { refresh().then(function () { reconcile(); }).catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
